import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import ReviewEditDto from 'app/admin/review/dto/ReviewEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class ReviewEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'reviewEditControl';
	}

	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new ReviewEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new ReviewEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {ReviewEditDto} review
	 * @return {Promise<EntityValidationResult>}
	 */
	submitReview(review) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/submitReview`, {
					review
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new ReviewEditService();